var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"}},[_c('v-select',{attrs:{"label":"text","options":_vm.option},model:{value:(_vm.selectedYears),callback:function ($$v) {_vm.selectedYears=$$v},expression:"selectedYears"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }